import * as React from 'react';

function SvgAlertTriangle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M12.007 16c.825 0 1.493.672 1.493 1.5 0 .77-.576 1.403-1.318 1.49l-.19.01a1.496 1.496 0 01-1.492-1.5c0-.77.576-1.403 1.318-1.49l.19-.01zM12 5.5a1.419 1.419 0 011.417 1.498l-.362 6.504a1.057 1.057 0 01-2.11 0l-.362-6.504A1.419 1.419 0 0112 5.5z" />
      <path d="M12 0a3.086 3.086 0 00-2.666 1.563L.414 17.19a3.31 3.31 0 00-.016 3.172A3.09 3.09 0 003.071 22h17.846a3.095 3.095 0 002.685-1.638c.534-.981.53-2.18-.008-3.159L14.669 1.568C14.108.597 13.097 0 12 0zm0 2c.375 0 .73.21.935.564l8.914 15.617c.203.368.204.844-.004 1.226-.2.368-.558.589-.94.593H3.084c-.37-.004-.729-.225-.928-.593a1.305 1.305 0 01.003-1.24l8.91-15.608C11.27 2.21 11.625 2 12 2z" />
    </svg>
  );
}

export default SvgAlertTriangle;
